import React from 'react';
import { ExternalLink, Building2 } from 'lucide-react';
import { Button } from './ui/button';

const PredimedInvite = ({ t }) => {
  return (
    <section
      id="predimed"
      className="py-24 bg-black relative overflow-hidden"
      data-testid="predimed-invite-section"
    >
      <div className="absolute inset-0 opacity-20">
        <div className="absolute top-0 left-1/3 w-96 h-96 bg-gold/10 rounded-full blur-3xl" />
        <div className="absolute bottom-0 right-1/3 w-96 h-96 bg-gold/10 rounded-full blur-3xl" />
      </div>

      <div className="relative z-10 max-w-5xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="rounded-3xl border border-gold/30 bg-gradient-to-br from-zinc-900/80 to-black p-10 md:p-16 text-center luxury-shadow">
          <div className="inline-flex items-center justify-center w-16 h-16 rounded-full bg-gold/10 border border-gold/30 mb-6">
            <Building2 className="h-8 w-8 text-gold" />
          </div>

          <h2
            className="text-3xl md:text-4xl lg:text-5xl font-bold text-white heading-luxury mb-4"
            data-testid="predimed-invite-title"
          >
            {t.predimedInvite.title}
          </h2>

          <div className="h-1 w-20 gold-gradient mx-auto mb-6" />

          <p className="text-lg md:text-xl text-gray-300 leading-relaxed max-w-2xl mx-auto mb-10 font-light">
            {t.predimedInvite.description}
          </p>

          <Button
            asChild
            size="lg"
            className="bg-gradient-to-r from-gold to-gold-light hover:from-gold-light hover:to-gold text-black font-semibold px-8 py-6 text-lg group shadow-2xl"
            data-testid="predimed-invite-cta"
          >
            <a
              href="https://predimed.pt"
              target="_blank"
              rel="noopener noreferrer"
            >
              {t.predimedInvite.cta}
              <ExternalLink className="ml-2 h-5 w-5 group-hover:translate-x-1 group-hover:-translate-y-1 transition-transform" />
            </a>
          </Button>
        </div>
      </div>
    </section>
  );
};

export default PredimedInvite;
